(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculator"] && !window.DesignMode) return;
  try {
    
var x, i, j, l, ll, selElmnt, a, b, c;

		x = document.getElementsByClassName("custom-select");
		l = x.length;
		for (i = 0; i < l; i++) {
			selElmnt = x[i].getElementsByTagName("select")[0];
			ll = selElmnt.length;
		
			a = document.createElement("DIV");
			a.setAttribute("class", "select-selected");
			a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
			x[i].appendChild(a);

			b = document.createElement("DIV");
			b.setAttribute("class", "select-items select-hide");
			for (j = 1; j < ll; j++) {
			
				c = document.createElement("DIV");
				c.innerHTML = selElmnt.options[j].innerHTML;
				c.addEventListener("click", function (e) {
		
					var y, i, k, s, h, sl, yl;
					s = this.parentNode.parentNode.getElementsByTagName("select")[0];
					sl = s.length;
					h = this.parentNode.previousSibling;
					for (i = 0; i < sl; i++) {
						if (s.options[i].innerHTML == this.innerHTML) {
							s.selectedIndex = i;
							h.innerHTML = this.innerHTML;
							y = this.parentNode.getElementsByClassName("same-as-selected");
							yl = y.length;
							for (k = 0; k < yl; k++) {
								y[k].removeAttribute("class");
							}
							this.setAttribute("class", "same-as-selected");
							break;
						}
					}
					h.click();
				});
				b.appendChild(c);
			}
			x[i].appendChild(b);
			a.addEventListener("click", function (e) {

				e.stopPropagation();
				closeAllSelect(this);
				this.nextSibling.classList.toggle("select-hide");
				this.classList.toggle("select-arrow-active");
			});
		}

		function closeAllSelect(elmnt) {

			var x, y, i, xl, yl, arrNo = [];
			x = document.getElementsByClassName("select-items");
			y = document.getElementsByClassName("select-selected");
			xl = x.length;
			yl = y.length;
			for (i = 0; i < yl; i++) {
				if (elmnt == y[i]) {
					arrNo.push(i)
				} else {
					y[i].classList.remove("select-arrow-active");
				}
			}
			for (i = 0; i < xl; i++) {
				if (arrNo.indexOf(i)) {
					x[i].classList.add("select-hide");
				}
			}
		}


		document.addEventListener("click", closeAllSelect);







		document.getElementById("berechnenBtn").addEventListener("click", berechne);


		function berechne() {
			// Ausgewähltes Gemüse und zugehörige Parameter
			var gemuese = document.getElementById("gemuese").value;
			var parameter = {
                    kartoffel: {
                    	ertrag: 3,
                    	ernten: 1,
                    	preis: 2.15,
                    	co2: 0.2,
                    	bedarf: 55,
                    	anzahl: 4,
                    	wasserbedarf: "niedrig",
                    	duenger: "hoch",
                    	kulturdauer: "Apr-Okt",
                    	ort: "Balkon/Terrasse, Freiland"
                    },
                    
                    tomate: {
                    	ertrag: 6,
                    	ernten: 1,
                    	preis: 4.4,
                    	co2: 9.3,
                    	bedarf: 21,
                    	anzahl: 2,
                    	wasserbedarf: "mittel",
                    	duenger: "hoch",
                    	kulturdauer: "März-Okt/Nov",
                    	ort: "Gewächshaus, Balkon/Terrasse"
                    },
                    
                    salatgurke: {
                    	ertrag: 9,
                    	ernten: 1,
                    	preis: 2,
                    	co2: 7,
                    	bedarf: 9,
                    	anzahl: 2,
                    	wasserbedarf: "mittel",
                    	duenger: "hoch",
                    	kulturdauer: "Apr-Okt",
                    	ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                    },
                    
                    aubergine: {
                    	ertrag: 2.5,
                    	ernten: 1,
                    	preis: 4,
                    	co2: 2.1,
                    	bedarf: 1,
                    	anzahl: 3,
                    	wasserbedarf: "mittel",
                    	duenger: "hoch",
                    	kulturdauer: "Jan/Feb-Okt",
                    	ort: "Gewächshaus"
                    },
                    
                    lauch: {
                    	ertrag: 2,
                    	ernten: 2,
                    	preis: 7,
                    	co2: 0.6,
                    	bedarf: 1.5,
                    	anzahl: 12,
                    	wasserbedarf: "mittel",
                    	duenger: "mittel",
                    	kulturdauer: "Feb-Dez",
                    	ort: "Freiland"
                    },
                    
                    kohlrabi: {
                    	ertrag: 2.5,
                    	ernten: 3,
                    	preis: 6.4,
                    	co2: 0.5,
                    	bedarf: 2.1,
                    	anzahl: 25,
                    	wasserbedarf: "mittel",
                    	duenger: "mittel",
                    	kulturdauer: "März-Okt",
                    	ort: "Im Frühjahr Gewächshaus, Freiland"
                    },
                    
                    blumenkohl: {
                    	ertrag: 2,
                    	ernten: 2,
                    	preis: 7,
                    	co2: 0.8,
                    	bedarf: 2.7,
                    	anzahl: 5,
                    	wasserbedarf: "hoch",
                    	duenger: "hoch",
                    	kulturdauer: "Ganzjährig (je nach Sorte)",
                    	ort: "Im Frühjahr Gewächshaus, Freiland"
                    },
                    
                    moehre: {
                    	ertrag: 2.5,
                    	ernten: 3,
                    	preis: 2,
                    	co2: 0.2,
                    	bedarf: 7.5,
                    	anzahl: 80,
                    	wasserbedarf: "niedrig",
                    	duenger: "mittel",
                    	kulturdauer: "Apr-Jan",
                    	ort: "Balkon/Terrasse, Freiland"
                    },
                    
                    paprika: {
                    	ertrag: 3,
                    	ernten: 1,
                    	preis: 15,
                    	co2: 1.8,
                    	bedarf: 3.9,
                    	anzahl: 5,
                    	wasserbedarf: "mittel",
                    	duenger: "hoch",
                    	kulturdauer: "Feb-Okt (kann überwintert werden)",
                    	ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                    },
                    
                    feldsalat: {
                    	ertrag: 1,
                    	ernten: 2,
                    	preis: 20,
                    	co2: 0.4,
                    	bedarf: 0.7,
                    	anzahl: 50,
                    	wasserbedarf: "niedrig",
                    	duenger: "niedrig",
                    	kulturdauer: "Okt-März",
                    	ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                    },
                    
                    zucchini: {
                    	ertrag: 3,
                    	ernten: 1,
                    	preis: 5,
                    	co2: 0.7,
                    	bedarf: 3.3,
                    	anzahl: 2,
                    	wasserbedarf: "mittel",
                    	duenger: "mittel",
                    	kulturdauer: "Apr-Sept",
                    	ort: "Freiland"
                    },
                    
                    kopfsalat: {
                    	ertrag: 1.5,
                    	ernten: 4,
                    	preis: 10,
                    	co2: 0.3,
                    	bedarf: 5.5,
                    	anzahl: 20,
                    	wasserbedarf: "mittel",
                    	duenger: "niedrig",
                    	kulturdauer: "Jan-Dez",
                    	ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                    },
                    
                    hokkaido_kuerbis: {
                    	ertrag: 2,
                    	ernten: 1,
                    	preis: 4,
                    	co2: 0.25,
                    	bedarf: 3.3,
                    	anzahl: 1,
                    	wasserbedarf: "mittel",
                    	duenger: "hoch",
                    	kulturdauer: "Apr-Okt",
                    	ort: "Freiland"
                    },
                    
                    spinat: {
                    	ertrag: 2,
                    	ernten: 2,
                    	preis: 5,
                    	co2: 0.2,
                    	bedarf: 4.5,
                    	anzahl: 100,
                    	wasserbedarf: "niedrig",
                    	duenger: "niedrig",
                    	kulturdauer: "Feb-Mai/Sep-Nov",
                    	ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                    },
                    
                    brokkoli: {
                    	ertrag: 1.5,
                    ernten: 2,
                    	preis: 6,
                    	co2: 0.4,
                    	bedarf: 2.5,
                    	anzahl: 8,
                    	wasserbedarf: "hoch",
                    	duenger: "hoch",
                    	kulturdauer: "Feb-Jun/Jul-Dez",
                    	ort: "Gewächshaus, Freiland"
                    },
                    
                    stangenbohne: {
                    	ertrag: 3,
                    	ernten: 1,
                    	preis: 9.5,
                    	co2: 0.3,
                    	bedarf: 1.6,
                    	anzahl: 12,
                    	wasserbedarf: "mittel",
                    	duenger: "niedrig",
                    	kulturdauer: "Mai-Okt",
                    	ort: "Freiland"
                    },
                    
                    zwiebel: {
                    	ertrag: 4,
                    	ernten: 1,
                    	preis: 4,
                    	co2: 0.15,
                    	bedarf: 8.9,
                    	anzahl: 40,
                    	wasserbedarf: "mittel",
                    	duenger: "mittel",
                    	kulturdauer: "März-Sept",
                    	ort: "Freiland, Balkon/Terrasse"
                    },
                    
                    knoblauch: {
                    	ertrag: 3,
                    	ernten: 1,
                    	preis: 30,
                    	co2: 0.15,
                    	bedarf: 0.7,
                    	anzahl: 40,
                    	wasserbedarf: "niedrig",
                    	duenger: "hoch",
                    	kulturdauer: "Okt-Jun",
                    	ort: "Freiland, Balkon/Terrasse"
                    },
                    
                    radieschen: {
                    	ertrag: 3,
                    	ernten: 4,
                    	preis: 10,
                    	co2: 0.2,
                    	bedarf: 0.9,
                    	anzahl: 100,
                    	wasserbedarf: "niedrig",
                    	duenger: "mittel",
                    	kulturdauer: "Feb-Nov",
                    	ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                    },
                    
                    snackpaprika: {
                    	ertrag: 2,
                    	ernten: 1,
                    	preis: 10,
                    	co2: 1.8,
                    	bedarf: 2.2,
                    	anzahl: 6,
                    	wasserbedarf: "mittel",
                    	duenger: "hoch",
                    	kulturdauer: "Feb-Okt (kann überwintert werden)",
                    	ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                    },
                    
                    mangold: {
                    	ertrag: 2,
                    	ernten: 1,
                    	preis: 5,
                    	co2: 0.25,
                    	bedarf: 1,
                    	anzahl: 8,
                    	wasserbedarf: "mittel",
                    	duenger: "mittel",
                    	kulturdauer: "Apr-Nov",
                    	ort: "Freiland, Balkon/Terrasse"
                    },

                     basilikum: {
                            ertrag: 1.5,
                            ernten: 1,
                            preis: 15,
                            co2: 1.8,
                            bedarf: 0.25,
                            anzahl: 16,
                            wasserbedarf: "mittel",
                            duenger: "niedrig",
                            kulturdauer: "Mai-Okt",
                            ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                        },
                    
                    
                              
                        schnittknoblauch: {
                            ertrag: 1.2,
                            ernten: 1,
                            preis: 13,
                            co2: 2,
                            bedarf: 0.1,
                            anzahl: 12,
                            wasserbedarf: "mittel",
                            duenger: "niedrig",
                            kulturdauer: "März-Okt (Mehrjährig)",
                            ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                        },
                                  
                        dill: {
                            ertrag: 0.8,
                            ernten: 1,
                            preis: 27,
                            co2: 1.9,
                            bedarf: 0.1,
                            anzahl: 10,
                            wasserbedarf: "mittel",
                            duenger: "niedrig",
                            kulturdauer: "Mai-Sep",
                            ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                        },
                                  
                        petersilie: {
                            ertrag: 1.2,
                            ernten: 1,
                            preis: 57,
                            co2: 1.8,
                            bedarf: 0.3,
                            anzahl: 15,
                            wasserbedarf: "mittel",
                            duenger: "mittel",
                            kulturdauer: "März-Okt (Mehrjährig)",
                            ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                        },
                                  
                        thymian: {
                            ertrag: 0.6,
                            ernten: 1,
                            preis: 25,
                            co2: 1.7,
                           bedarf: 0.15,
                            anzahl: 10,
                            wasserbedarf: "Klein",
                            duenger: "niedrig",
                            kulturdauer: "März-Okt (Mehrjährig)",
                            ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                        },
                    
                    koriander: {
                            ertrag: 1,
                            ernten: 1,
                            preis: 15.7,
                            co2: 1.9,
                            bedarf: 0.1,
                            anzahl: 12,
                            wasserbedbedarf: "mittel",
                            duenger: "niedrig",
                            kulturdauer: "April-Sep",
                            ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                            },
                    
                    oregano: {
                          ertrag: 0.5,
                          ernten: 1,
                          preis: 27,
                          co2: 1.7,
                          bedarf: 0.2,
                          anzahl: 8,
                          wasserbedarf: "niedrig",
                          duenger: "niedrig",
                          kulturdauer: "März-Okt (Mehrjährig)",
                          ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                          },
                    
                    schnittlauch: {
                          ertrag: 1,
                          ernten: 1,
                          preis: 26,
                          co2: 1.8,
                         bedarf: 0.25,
                          anzahl: 15,
                          wasserbedarf: "mittel",
                          duenger: "niedrig",
                          kulturdauer: "März-Okt (Mehrjährig)",
                          ort: "Gewächshaus, Balkon/Terrasse, Freiland"
                          }

              
			};


			var flaeche = parseFloat(document.getElementById("flaeche").value);
			var kosten = parseFloat(document.getElementById("kosten").value);


			var ertrag_pro_jahr = parameter[gemuese].ertrag * flaeche * parameter[gemuese].ernten;
			var ernten_jahr = parameter[gemuese].ernten;
 			var ersparnis = parameter[gemuese].ertrag * flaeche * parameter[gemuese].ernten * parameter[gemuese].preis;         
			var amortisierung = kosten / (ertrag_pro_jahr * parameter[gemuese].preis);
			var co2_ersparnis = parameter[gemuese].co2 * ertrag_pro_jahr;
			var selbstversorgung = (parameter[gemuese].bedarf / parameter[gemuese].ertrag);
			var wasserbedarf = parameter[gemuese].wasserbedarf;
            var duenger = parameter[gemuese].duenger;
			var kulturdauer = parameter[gemuese].kulturdauer;
			var ort = parameter[gemuese].ort;

			document.getElementById("ertrag").innerHTML = ertrag_pro_jahr.toFixed(2);
			document.getElementById("ernten_jahr").innerHTML = ernten_jahr.toFixed(2);          
			document.getElementById("ersparnis").innerHTML = ersparnis.toFixed(2);          
			document.getElementById("amortisierung").innerHTML = amortisierung.toFixed(2);
			document.getElementById("co2").innerHTML = co2_ersparnis.toFixed(2);
			document.getElementById("selbstversorgung").innerHTML = selbstversorgung.toFixed(2);
          	document.getElementById("wasserbedarf").innerHTML = wasserbedarf;
			document.getElementById("duenger").innerHTML = duenger;
 			document.getElementById("kulturdauer").innerHTML = kulturdauer; 
			document.getElementById("ort").innerHTML = ort;
		}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
